import React from 'react';
import ProductItemRow from "./ProductItemRow.js";
import {Table} from "reactstrap";
import {PlaceholderTable} from "../PlaceholderTable/PlaceholderTable";

const ProductsTable = ({products, isLoading, visibleColumns, getColumnName}) => {
  return (
    <>
      {
        isLoading === true ? <PlaceholderTable rows={20}/> :
          <Table className="align-items-center table-flush mt-3">
            <thead className="thead-light ">
            <tr>
              {visibleColumns.map(columnId => (
                <th key={columnId} className={'text-center'}>
                  {getColumnName(columnId)}
                </th>
              ))}
            </tr>
            </thead>
            <tbody className='list'>
            {
              products && products.map((product, i) =>
                <ProductItemRow
                  key={i}
                  data={product}
                  visibleColumns={visibleColumns}
                />
              )}
            </tbody>
          </Table>
      }
    </>
  )
}


export default ProductsTable;
